import { m } from 'framer-motion';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { useResponsive } from 'src/hooks/use-responsive';

import Iconify from 'src/components/iconify';
import { varHover } from 'src/components/animate';

// ----------------------------------------------------------------------

// "Help center" in the top bar, on every page: one click opens the help center. The chat with us is at the
// bottom of the side menu.
export default function HelpCenterButton () {
  const router = useRouter();

  const mdUp = useResponsive('up', 'md');

  const openHelpCenter = () => router.push(paths.knowledgeBase.root);

  if (mdUp) {
    return (
      <Button
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        onClick={openHelpCenter}
        startIcon={<Iconify icon="solar:question-circle-bold" width={20} />}
        sx={{ color: 'text.secondary', fontWeight: 600, fontSize: '0.8125rem', px: 1.5, minWidth: 'auto' }}
      >
        Help center
      </Button>
    );
  }

  return (
    <IconButton
      component={m.button}
      whileTap="tap"
      whileHover="hover"
      variants={varHover(1.05)}
      onClick={openHelpCenter}
      aria-label="Help center"
      sx={{ width: 40, height: 40 }}
    >
      <Iconify icon="solar:question-circle-bold" width={24} />
    </IconButton>
  );
}
